import { X } from "lucide-react";

export const SaveStyleForm = ({ name, onNameChange, onConfirm, onCancel }) => (
    <div className="mt-4 flex gap-2" data-testid="save-preset-form">
        <input
            value={name}
            onChange={onNameChange}
            onKeyDown={(e) => e.key === "Enter" && onConfirm()}
            placeholder="Name this style (saves the current prompt)..."
            autoFocus
            className="flex-1 min-w-0 bg-obsidian border border-white/10 text-white px-3 py-2.5 font-mono text-xs outline-none focus:border-electric placeholder:text-white/20 transition-colors"
            data-testid="save-preset-name-input"
        />
        <button
            onClick={onConfirm}
            className="px-5 bg-blaze hover:bg-blazeHover text-white font-mono uppercase text-[11px] tracking-[0.2em] transition-colors"
            data-testid="save-preset-confirm-button"
        >
            Save
        </button>
        <button
            onClick={onCancel}
            className="px-3 border border-white/20 hover:border-white/60 text-white transition-colors"
            data-testid="save-preset-cancel-button"
        >
            <X className="w-3.5 h-3.5" />
        </button>
    </div>
);
